import useI18nContext from '@rover/react-lib/src/context/useI18nContext';
import { FLAGS } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';
import useFrontendConfigurationShim from '@rover/shared/js/hooks/useFrontendConfigurationShim';

const useInTrainingPilot = (): {
  inTrainingPilot: boolean;
  inTrainingPilotGlobal: boolean;
  inTrainingPilotTrainerSignup: boolean;
  inTrainingPilotTrainerSignupGlobal: boolean;
  shouldShowTrainingEntrypoints: boolean;
} => {
  const { isFlagActive } = useFrontendConfigurationShim();
  const { locale } = useI18nContext();
  const isPageInUSEnglish = locale === 'en-us';
  return {
    inTrainingPilot: isFlagActive(FLAGS.ROLLOUT_DOG_TRAINING_PILOT),
    inTrainingPilotGlobal: isFlagActive(FLAGS.ROLLOUT_DOG_TRAINING_PILOT_GLOBAL),
    inTrainingPilotTrainerSignup: isFlagActive(FLAGS.ROLLOUT_TRAINER_SIGN_UP),
    inTrainingPilotTrainerSignupGlobal: isFlagActive(FLAGS.ROLLOUT_TRAINER_SIGN_UP_GLOBAL),
    shouldShowTrainingEntrypoints:
      isPageInUSEnglish && isFlagActive(FLAGS.ROLLOUT_DOG_TRAINING_ENTRYPOINTS),
  };
};

export default useInTrainingPilot;
